import { AuxiliumComponent } from "../auxilium-component";

export default class Form extends AuxiliumComponent {
  static observableBooleans = ["readonly", "centre-rows"];

  #DefaultOptions = {
    ProcessCheckboxes: true,
    AllowUncheckedBoxes: false
  }

  #getAllControls() {
    return [...this.querySelectorAll("chip-input, chip-textarea, chip-dropdown, chip-select, chip-checkbox, chip-calendar") ?? []];
  }

  parsedCallback() {
    this.#refreshReadonly();
  }

  reportValidity() {
    const validity = this.#getAllControls().filter(x => !x.reportValidity()).length === 0,
      tab = this.closest(".tab-group__tab");

    if (tab) {
      const index = [...tab.parentElement.children].indexOf(tab),
        group = tab.closest("chip-tabgroup");

      if (!validity) {
        group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.add("step__invalid");
      } else if (!tab.querySelector(".input-field__invalid")) {
        group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.remove("step__invalid");
      }
    }

    return validity;
  }

  #refreshReadonly() {
    this.#getAllControls().forEach(control => control.toggleReadonly(this.readonly));
  }

  checkValidity() {
    const validity = this.#getAllControls().filter(x => !x.checkValidity()).length === 0,
      tab = this.closest(".tab-group__tab");

    if (tab) {
      const index = [...tab.parentElement.children].indexOf(tab),
        group = tab.closest("chip-tabgroup");

      if (validity) {
        group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.remove("step__invalid");
      }
    }

    return validity;
  }

  attributeChanged(name) {
    if (name === "readonly") {
      this.#refreshReadonly();
    }
  }

  getData(options = {}) {
    options = { ...this.#DefaultOptions, ...options };

    const elements = this.querySelectorAll(`chip-input[name], chip-buttongroup[name], chip-textarea[name], chip-dropdown[name], chip-select[name], chip-calendar[name], chip-radio[name]${options.AllowUncheckedBoxes ? "" : "[checked]"}, chip-checkbox[name]${options.AllowUncheckedBoxes ? "" : "[checked]"}`) ?? [];

    if (!elements.length) {
      return {};
    }

    return Object.assign(...[...elements].
      map(x => {
        let value = x.value;

        if (x.nodeName === "CHIP-CHECKBOX" && options.ProcessCheckboxes) { value = x.checked; }
        else if (x.nodeName === "CHIP-INPUT" && x.type === "number") { value = parseFloat(value); }
        else if (x.nodeName === "CHIP-INPUT" && x.type === "date" && !x.value) { value = null; }
        else if (x.nodeName === "CHIP-INPUT" && x.type === "datetime-local") {
          value = new Date(value).toISOString();
        }

        return { [x.name]: value };
      }));
  }
}
